import React from 'react'
import { UIBadge, type UIBadgeProps } from './ui-badge'
import { cn } from '../../lib/utils'
import { UIBox } from '../layout/ui-box'

export interface UIBadgeGradientOutlineProps extends Omit<UIBadgeProps, 'children'> {
  children?: React.ReactNode
  gradientFrom?: string
  gradientTo?: string
  padding?: 'xs' | 'sm' | 'default'
}

/**
 * UIBadgeGradientOutline - Gradient Outline Badge Block
 * 그라디언트 아웃라인의 배지 컴포넌트입니다.
 * 그라디언트 아웃라인의 배지입니다.
 */
export const UIBadgeGradientOutline = React.forwardRef<HTMLDivElement, UIBadgeGradientOutlineProps>(
  ({
    children = "Gradient Outline",
    gradientFrom = "from-sky-400",
    gradientTo = "to-indigo-600",
    padding = "default",
    className,
    ...props
  }, ref) => {
    const paddingVariants = {
      xs: "p-0.5",
      sm: "p-1",
      default: "p-0.5"
    }

    return (
      <UIBox
        ref={ref}
        className={cn(
          "bg-gradient-to-r rounded-full flex items-center justify-center",
          gradientFrom,
          gradientTo,
          paddingVariants[padding],
          className
        )}
      >
        <UIBadge
          shape="pill"
          className="bg-background text-foreground border-none"
          {...props}
        >
          {children}
        </UIBadge>
      </UIBox>
    )
  }
)

UIBadgeGradientOutline.displayName = "UIBadgeGradientOutline"